<style scoped>
  .container{
    position: relative;
  }
  .hrr {
    display: block;
    width: 100%;
    height: 1px;
    background: #dddee1;
  }
  .handler-container{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
  }
  .flow-title{
    display: inline-block;
    vertical-align: middle;
    margin-left: 10px;
  }
  .node-editor, .edge-editor{
    position: absolute;
    top: 30px;
    right: 0;
    width: 510px;
    /* padding: 10px; */
    border: 1px solid #dddee1;
    border-radius: 5px;
    background: white;
    box-shadow: -1px 1px 3px 0 rgba(0,0,0,.2);
    resize:both;
    overflow:auto;
  }
  .panel-contain {
    padding: 10px;
  }
  .editor-title{
    padding: 10px;
    font-size: 16px;
    font-weight: bold;
    user-select:none;
  }
  .can-drag {
    cursor: move;
  }
  .form-line{
    display: table;
    margin-top: 5px;
    width: 100%;
  }
  .form-line:first-child{
    margin-top: 0;
  }
  .form-label{
    display: table-cell;
    width: 40px;
    vertical-align: middle;
    text-align: right;
    padding-right: 5px;
  }
  .form-item{
    display: table-cell;
  }
  .delete-condition-btn{
    cursor: pointer;
  }
  .delete-condition-btn:hover{
    color: #ed3f14;
  }
  .node-user-selected{
    color: #2D8CF6;
    cursor: pointer;
  }
  .node-user-selected:hover{
    text-decoration: underline;
  }
  .select-customer-container{
    white-space: normal;
    margin-top: 5px;
  }
  .select-customer{
    display: block;
    margin-right: 5px;
    margin-bottom: 5px;
    padding: 3px 6px;
    border: 1px solid #dddee1;
    border-radius: 4px;
    cursor: pointer;
  }
  .select-customer:hover{
    background: #e5e5e5;
  }
  .select-customer-disabled{
    background: #e5e5e5;
    color: #999;
    cursor: auto;
  }
  .select-customer-disabled:hover{
    background: #e5e5e5;
  }
  .auto-tj {
    position: absolute;
    bottom: 10px;
    background: #dddee1;
    
  }
</style>
<template>
  <div
    ref="container"
    class="container"
  >
    <div class="handler-container">
      <Dropdown @on-click="addShape">
        <Button
          type="primary"
          icon="ios-git-commit"
        >
          添加图形
        </Button>
        <DropdownMenu slot="list">
          <DropdownItem
            v-for="shape in shapes"
            :key="shape.value"
            :name="shape.value"
          >
            {{ shape.name }}
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <space />
      <Dropdown @on-click="addLine">
        <Button
          type="primary"
          icon="ios-git-branch"
        >
          添加线条
        </Button>
        <DropdownMenu slot="list">
          <DropdownItem name="arrow">
            线
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <space />
      <Button
        type="primary"
        icon="md-create"
        :disabled="mode === 'edit'"
        @click="changeMode('edit')"
      >
        编辑
      </Button>
      <space />
      <Button
        type="primary"
        icon="md-move"
        :disabled="mode === 'drag'"
        @click="changeMode('drag')"
      >
        拖动
      </Button>
      <span class="flow-title text-large">
        {{ flow.name }}
      </span>
    </div>
    <div id="flow-test" />
    <div
      v-show="show_node_editor"
      class="node-editor"
      :style="`left:${grag_node_left}px;top:${grag_node_top}px`"
    >
      <div
        class="editor-title can-drag"
        @mousemove="e=>nodeMove(e)"
        @mousedown="nodeMoveReady"
      >
        节点编辑
      </div>
      <div class="hrr" />
      <div class="panel-contain">
        <div class="form-line">
          <div class="form-label">
            文字
          </div>
          <div class="form-item">
            <i-input
              v-model="edit_node_attrs.label"
              placeholder="text..."
              @on-change="renderNode"
            />
          </div>
        </div>
        <div class="form-line">
          <div class="form-label">
            形状
          </div>
          <div class="form-item">
            <Select
              v-model="edit_node_attrs.shape"
              @on-change="renderNode"
            >
              <Option
                v-for="shape in shapes"
                :key="shape.value"
                :value="shape.value"
              >
                {{ shape.name }}
              </Option>
            </Select>
          </div>
        </div>
        <div class="form-line">
          <div class="form-label">
            备注
          </div>
          <div class="form-item">
            <i-input
              v-model="edit_node_attrs.desc"
              placeholder="text..."
              @on-change="renderNode"
            />
          </div>
        </div>
        <div class="form-line">
          <div class="form-label">
            天数
          </div>
          <div class="form-item">
            <InputNumber
              v-model="edit_node_attrs.duration"
              placeholder="text..."
              @on-change="renderNode"
            />
          </div>
        </div>
        <div class="hr" />
        <div class="form-line">
          <Row>
            <i-col span="5">
              <Checkbox
                v-model="edit_node_attrs.send_notice"
                @on-change="renderNode"
              >
                是否通知
              </Checkbox>
            </i-col>
            <i-col span="5">
              <Checkbox
                v-model="edit_node_attrs.skip_fill_user"
                @on-change="renderNode"
              >
                跳过填写人
              </Checkbox>
            </i-col>
            <i-col span="5">
              <Checkbox
                v-model="edit_node_attrs.skip_apply_user"
                @on-change="renderNode"
              >
                跳过申请人
              </Checkbox>
            </i-col>
            <i-col span="5">
              <Checkbox
                v-model="edit_node_attrs.forbid_fail"
                @on-change="renderNode"
              >
                不可驳回
              </Checkbox>
            </i-col>
            <i-col span="8">
              <span>节点通过策略</span>
              <Select
                v-model="edit_node_attrs.op_type"
                size="small"
                style="width: 60px"
                @on-change="renderNode"
              >
                <Option value="and">
                  And
                </Option>
                <Option value="or">
                  Or
                </Option>
              </Select>
            </i-col>
          </Row>
        </div>
        <div class="hr" />
        <div class="form-line">
          <Button
            size="small"
            long
            icon="md-add"
            @click="addNodeUser"
          >
            添加节点人员
          </Button>
        </div>
        <div class="form-line">
          <table class="mis-table">
            <thead>
              <tr>
                <th width="100">
                  用户类型
                </th>
                <th width="70">
                  TL层级
                </th>
                <th width="70">
                  操作类型
                </th>
                <th>用户</th>
                <th>模型字段名</th>
                <th width="60">
                  自动通过
                </th>
                <th width="40">
                  操作
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(node_user, index) in edit_node_attrs.node_users"
                :key="node_user.id"
              >
                <td>
                  <Select
                    v-model="node_user.user_type"
                    size="small"
                    placeholder="用户类型"
                    @on-change="updateNodeUser(node_user)"
                  >
                    <Option
                      value="user"
                      label="指定用户"
                    />
                    <!--<Option-->
                    <!--  value="team-leader"-->
                    <!--  label="直属团队Leader"-->
                    <!--/>-->
                    <Option
                      value="tl"
                      label="TL"
                    />
                    <Option
                      value="team-leader"
                      label="TeamLeader"
                    />
                    <Option
                      value="pl"
                      label="项目负责人"
                    />
                    <Option
                      value="director"
                      label="实习生负责人"
                    />
                    <Option
                      value="model-key"
                      label="模型字段名"
                    />
                  </Select>
                </td>
                <td>
                  <span v-show="node_user.user_type!=='team-leader'">
                    /
                  </span>
                  <Select
                    v-show="node_user.user_type==='team-leader'"
                    v-model="node_user.tl_level"
                    size="small"
                    style="width: 60px"
                
                    @on-change="updateNodeUser(node_user)"
                  >
                    <Option
                      v-for="i in node_level"
                      :key="i"
                      :value="i"
                      :label="i"
                    />
                  </Select>
                </td>
                <td>
                  <Select
                    v-model="node_user.action_type"
                    size="small"
                    style="width: 60px"
                    placeholder="操作类型"
                    @on-change="updateNodeUser(node_user)"
                  >
                    <Option
                      value="submit"
                      label="提交"
                    />
                    <Option
                      value="check"
                      label="审核"
                    />
                    <Option
                      value="handle"
                      label="处理"
                    />
                    <Option
                      value="finish"
                      label="完成"
                    />
                    <Option
                      value="confirm"
                      label="确认"
                    />
                  </Select>
                </td>
                <td>
                  <div v-show="node_user.user_type === 'user'">
                    <Poptip
                      placement="bottom"
                      width="300"
                    >
                      <span class="node-user-selected">{{ getUserName(node_user.user_id) }}</span>
                      <div
                        slot="content"
                        class="pop-tip-content"
                      >
                        <i-input
                          v-model="search_user_text"
                          placeholder="搜索用户..."
                          @on-enter="searchUser"
                        >
                          <Button
                            slot="append"
                            :loading="search_user_loading"
                            @click="searchUser"
                          >
                            搜索
                          </Button>
                        </i-input>
                        <div class="select-customer-container">
                          <div
                            v-for="customer in search_user_result"
                            :key="customer.id"
                            class="select-customer"
                            :class="{'select-customer-disabled': customer.id === node_user.user_id}"
                            @click="setUser(node_user, customer)"
                          >
                            <span>{{ customer.uid }} - </span>
                            <span>{{ customer.account }} - </span>
                            <span>{{ customer.team_name || '未设置团队' }}</span>
                          </div>
                        </div>
                      </div>
                    </Poptip>
                  </div>
                  <div v-show="node_user.user_type !== 'user'">
                    <span>动态确定</span>
                  </div>
                </td>
                <td>
                  <div v-show="node_user.user_type === 'model-key'">
                    <i-input
                      v-model="node_user.model_key"
                      size="small"
                      placeholder="..."
                      @on-blur="updateNodeUser(node_user)"
                    />
                  </div>
                </td>
                <td>
                  <input
                    v-model="node_user.auto_pass"
                    type="checkbox"
                    @change="updateNodeUser(node_user)"
                  >
                  <button
                    v-if="node_user.auto_pass"
                    style="font-size:12px;color:#2d8cf0"
                    @click="showAutoParams(node_user)"
                  >
                    添加条件/查看
                  </button>
                </td>
                <td width="40">
                  <Poptip
                    placement="left-end"
                    confirm
                    title="您确认删除吗?"
                    transfer
                    @on-ok="deleteNodeUser(node_user, index)"
                  >
                    <span class="delete-node_user-btn">
                      <Icon
                        type="md-close"
                        size="16"
                      />
                    </span>
                  </Poptip>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="hr" />
        <ConditionEditor
          type="FlowNode"
          :edit_item_attrs="edit_node_attrs"
        />
      </div>
    </div>
    <!-- 编辑线条 -->
    <div
      v-show="show_edge_editor"
      class="edge-editor"
      :style="`left:${grag_node_left}px;top:${grag_node_top}px`"
    >
      <div
        class="editor-title can-drag"
        @mousemove="e=>nodeMove(e)"
        @mousedown="nodeMoveReady"
      >
        线条编辑
      </div>
      <div class="hrr" />
      <div class="panel-contain">
        <div class="form-line">
          <div class="form-label">
            文字
          </div>
          <div class="form-item">
            <i-input
              v-model="edit_edge_attrs.label"
              placeholder="text..."
              @on-change="renderEdge"
            />
          </div>
        </div>
        <ConditionEditor
          type="FlowEdge"
          :edit_item_attrs="edit_edge_attrs"
        />
      </div>
    </div>
    <div
      v-if="show_node_auto_pass"
      class="node-editor"
      :style="`left:${node_auto_pass_coord.x}px;top:${node_auto_pass_coord.y}px`"
    >
      <div
        class="editor-title can-drag"
        @mousemove="e=>nodeMove(e,'auto_pass')"
        @mousedown="nodeMoveReady"
      >
        <div style="display:flex">
          <div style="flex:1">
            自动通过
          </div>
          <div> 
            <v-icon
              style="cursor: pointer;"
              @click="closeAutoPassEdit"
            >
              mdi-close
            </v-icon>
          </div>
        </div>
      </div>
      <div class="hrr" />
      <div class="panel-contain">
        <!-- <AutoPassConditionEditor 
          v-if="!!auto_pass_node"
          v-model="auto_pass_node" -->
        <ConditionEditor
          type="FlowNodeUser"
          :edit_item_attrs="auto_pass_node"
        />
      </div>
    </div>
  </div>
</template>
<script :route="{path: '/flow/edit/:id',noChkout: true}">
  import Util from '../../libs/util';
  import ConditionEditor from './components/condition_editor';
  import G6 from '@antv/g6';
  const node_level = [1, 2, 3, 4, 5]
  export default {
    components: { ConditionEditor },
    data() {
      this.node_level = node_level
      return {
        grag_node_contain_left: null,
        grag_node_contain_top: null,
        grag_control: false,
        grag_node_left: '',
        grag_node_top: '',
        shapes: [
          {value: 'rect', name: '矩形'},
          {value: 'circle', name: '圆形'},
          {value: 'rhombus', name: '菱形'},
        ],
        mode: 'edit',
        flow: {
          //
        },
        nodes: [],
        edges: [],
        net_data: {
          source:
            {
              nodes: [
                {
                  id: -1,
                  shape: "rect",
                  label: 'test',
                  x: 370,
                  y: 120,
                  extra: 'test'
                },
                {
                  id: -2,
                  shape: "rhombus",
                  label: 'rhombus',
                  x: 370,
                  y: 260
                }
              ],
              edges:[
                {
                  id: -3,
                  shape: "arrow",
                  source: -1,
                  target: -2,
                  label: 'kjfaka dflafajl;fja; sjfal;sjdfal;sjdfl;ajsdf'
                }
              ]
            },
          guides:[]
        },
        edit_type: '',
        edit_node_attrs: {},
        node_attrs: {
          id: 0,
          label: '',
          desc: '',
          duration: 0,
          shape: 'rect',
          x: 0,
          y: 0,
          skip_fill_user: false,
          skip_apply_user: false,
          send_notice: true,
          op_type: 'and',
          node_users: [],
          conditions: [],
          forbid_fail: false,
        },
        show_node_editor: false,
        edit_edge_attrs: {},
        edge_attrs: {
          id: 0,
          label: '',
          conditions: []
        },
        show_edge_editor: false,
        customers_hash: {},
        search_user_text: '',
        search_user_result: [],
        search_user_loading: false,
        show_node_auto_pass: false,
        node_auto_pass_coord: {
          x: 0,
          y: 0
        },
        auto_pass_node: null,
      }
    },
    computed: {
      //
    },
    watch: {
      show_node_editor(val) {
        if (!val) {
          this.show_node_auto_pass = false
          return 
        }
      },
      edit_node_attrs(new_val, pre_val) {
        if (new_val.id !== pre_val.id) {
          this.show_node_auto_pass = false
        }
      }
    },
    created() {
      //
    },
    mounted() {
      this.getFlowDate();
      this.initNodeMove(true)
    },
    destroyed() {
      this.initNodeMove()
    },
    methods: {
      closeAutoPassEdit() {
        this.show_node_auto_pass = false
      },
      showAutoParams(node) {
        this.auto_pass_node = node
       
        if (this.show_node_auto_pass) {
          return
        }
        this.show_node_auto_pass = true
        this.node_auto_pass_coord = {
          x: Number(this.grag_node_left) || 0 + 100,
          y: Number(this.grag_node_top) || 0 + 100
        }
      
      },
      initNodeMove(is_mounted) {
        const key = is_mounted ? 'addEventListener' : 'removeEventListener'
        window[key]('mouseup', this.gragControlFalse)
      },
      gragControlFalse() {
        this.grag_control = false
      
      },
      nodeMoveReady(e) {
        const container = this.$refs.container
        const location = container && container.getBoundingClientRect && container.getBoundingClientRect() 
        if (!location) {
          return 
        }
        const x = location.x
        const y = location.y 
        this.grag_node_contain_left = x + e.offsetX
        this.grag_node_contain_top = y + e.offsetY
        this.grag_control = true
      },
      nodeMove(e, type) {
        if (!this.grag_control) {
          return 
        }
        if (type === 'auto_pass') {
          this.node_auto_pass_coord = {
            x:  e.pageX - this.grag_node_contain_left,
            y:  e.pageY - this.grag_node_contain_top
          }
          return  
        }
    
        this.grag_node_left = e.pageX - this.grag_node_contain_left // - 10 - e.offsetX
        this.grag_node_top = e.pageY - this.grag_node_contain_top // - 15 - e.offsetY 
      },
      getFlowDate() {
        Util.ajax.get(Util.api.flow_edit_info, {
          params: {
            id: this.$route.params.id
          }
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const data = res.data;
            this.flow = data.flow;
            this.nodes = [];
            this.edges = [];
            data.nodes.forEach((node) => {
              if (node.data) {
                const node_data = JSON.parse(node.data);
                node_data.node_users = node.node_users;
                node_data.conditions = node.conditions;
                this.nodes.push(node_data);
                node_data.node_users.forEach((node_user) => {
                  const user = node_user.user;
                  if (user) {
                    this.customers_hash[user.id] = user;
                  }
                })
              }
            });
            data.edges.forEach((edge) => {
              if (edge.data) {
                const edge_data = JSON.parse(edge.data);
                edge_data.conditions = edge.conditions;
                this.edges.push(edge_data);
              }
            });
            this.init();
          } else {
            this.$Modal.error({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          console.log(e);
          this.$Message.error('获取数据失败, 请重试!');
        })
      },
      init() {
        window.net = this.net = new G6.Net({
          id: 'flow-test', // 容器ID
          mode: 'edit', // 编辑模式
          fitView: 'cc', // 自适应视口为左上
          height: window.innerHeight - 140 // 画布高
        });
        this.net.source(this.nodes, this.edges);
        this.net.render();

        this.net.on('click', (ev) => {
          console.log(ev);
          if (ev.itemType === 'node' && this.mode === 'edit') {
            this.edit_type = 'node';
            this.editNode(ev.item);
          } else if (ev.itemType === 'edge' && this.mode === 'edit') {
            this.edit_type = 'edge';
            this.editEdge(ev.item);
          } else {
            this.edit_type = '';
            this.closeNodeEditor();
            this.closeEdgeEditor();
          }
        });
        /*this.net.on('dblclick', (ev)=>{
            console.log(ev);
            if(ev.itemType === 'node'){
                this.editNode(ev.item);
            }
        });*/

        this.net.on('itemremove', () => {
          console.log(this.edit_type);
          if (this.edit_type === 'node') {
            this.deleteNode();
          } else if (this.edit_type === 'edge') {
            this.deleteEdge();
          }
          this.edit_type = '';
        });

        this.net.on('itemadd', (ev) => {
          console.log('add', ev);
          this.itemUpdate(ev);
        });
        this.net.on('itemupdate', (ev) => {
          console.log('update', ev);
          this.itemUpdate(ev);
        });
      },
      changeMode(mode) {
        this.net.changeMode(mode);
        this.mode = mode;
        this.closeNodeEditor();
        this.closeEdgeEditor();
      },
      getUserName(user_id) {
        const user = this.customers_hash[user_id];
        const empty_text = user_id ? '未找到对应用户' : '请选择';
        return user ? user.account : empty_text;
      },
      itemUpdate(ev) {
        const itemType = ev.item._attrs.type;
        const itemData = ev.item._attrs.model;
        if (itemType === 'node') {
          this.updateNode(itemData);
        } else if (itemType === 'edge') {
          this.updateEdge(itemData);
        }
      },
      editNode(node) {
        this.cur_node = node;
        this.edit_node_attrs = Object.assign(Util.clone(this.node_attrs), node._attrs.model);
        this.show_node_editor = true;
        this.show_edge_editor = false;
        this.grag_node_left = 0
        this.grag_node_contain_top = 0
      },
      editEdge(edge) {
        this.cur_edge = edge;
        this.edit_edge_attrs = Object.assign(Util.clone(this.edge_attrs), edge._attrs.model);
        this.show_edge_editor = true;
        this.show_node_editor = false;
      },
      renderNode() {
        this.net.update(this.cur_node, this.edit_node_attrs);
      },
      renderEdge() {
        this.net.update(this.cur_edge, this.edit_edge_attrs);
      },
      updateNode(node_data) {
        //todo 生成更改队列, 如果队列里上一个item的id和此次更新相同, 则删除掉队列里的item, 避免多次提交
        Util.ajax.post(Util.api.update_node, {
          id: node_data.id,
          data: node_data
        }).then((response) => {
          return response.data;
        }).then((data) => {
          console.log(data);
        }).catch((e) => {
          console.log(e);
          this.$Message.error('保存节点失败');
        });
      },
      deleteNode() {
        Util.ajax.post(Util.api.delete_node, {
          id: this.edit_node_attrs.id,
        }).then((response) => {
          return response.data;
        }).then((data) => {
          console.log(data);
        }).catch((e) => {
          console.log(e);
          this.$Message.error('删除节点失败');
        });
      },
      deleteEdge() {
        Util.ajax.post(Util.api.delete_edge, {
          id: this.edit_edge_attrs.edge_id,
        }).then((response) => {
          return response.data;
        }).then((data) => {
          console.log(data);
        }).catch((e) => {
          console.log(e);
          this.$Message.error('删除线条失败');
        });
      },
      deleteNodeUser(node_user, index) {
        const node_data = this.edit_node_attrs;
        Util.ajax.post(Util.api.delete_flow_node_user, {
          id: node_user.id,
        }).then((response) => {
          return response.data;
        }).then((data) => {
          console.log(data);
          node_data.node_users.splice(index, 1);
        }).catch((e) => {
          console.log(e);
          this.$Message.error('删除条件失败');
        });
      },
      updateEdge(edge_data) {
        Util.ajax.post(Util.api.update_edge, {
          id: edge_data.edge_id,
          data: edge_data
        }).then((response) => {
          return response.data;
        }).then((data) => {
          console.log(data);
        }).catch((e) => {
          console.log(e);
          this.$Message.error('保存线条失败');
        });
      },
      updateNodeUser(node_user) {
        const {tl_level, ...other} = node_user
        if (other.user_type === 'team-leader') {
          other.tl_level = tl_level
          if (!tl_level) {
            node_user.tl_level = 1
          }
        } else {
          node_user.tl_level = null
        }
        Util.ajax.post(Util.api.update_flow_node_user, node_user).then((response) => {
          return response.data;
        }).then((data) => {
          console.log(data);
        }).catch((e) => {
          console.log(e);
          this.$Message.error('保存条件失败');
        });
      },
      closeNodeEditor() {
        this.show_node_editor = false;
      },
      closeEdgeEditor() {
        this.show_edge_editor = false;
      },
      addShape(shape) {
        Util.ajax.get(Util.api.get_new_node, {
          params: {
            flow_id: this.flow.id
          }
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const data = res.data;
            this.net.add('node', {
              id: data.id,
              shape: shape,
              x: 100,
              y: 100,
              label: '',
              node_users: []
            });
          } else {
            this.$Modal.error({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          console.log(e);
          this.$Message.error('新建节点失败');
        });
        /*this.net.beginAdd('node', {
            id: this.id--,
            shape: shape
        });*/
      },
      addLine(shape) {
        if (this.net.getNodes().length < 2) {
          this.$Message.success('节点少于2个, 不能添加线条');
          return;
        }
        Util.ajax.get(Util.api.get_new_edge, {
          params: {
            flow_id: this.flow.id
          }
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const data = res.data;
            this.net.beginAdd('edge', {
              id: `e${data.id}`,
              edge_id: data.id,
              shape: shape,
              label: '',
              conditions: []
            });
            this.$Message.success('点击节点设置关联');
          } else {
            this.$Modal.error({
              title: '错误',
              content: res.msg
            });
          }
        }).catch(() => {
          this.$Message.error('新建节点失败');
        });
        /*this.net.beginAdd('edge', {
            id: this.id--,
            shape: shape
        });*/
      },
      addNodeUser() {
        const node_data = this.edit_node_attrs;
        Util.ajax.get(Util.api.add_flow_node_user, {
          params: {
            flow_node_id: node_data.id
          }
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const data = res.data;
            data.tl_level = 1
            node_data.node_users.push(data);
          } else {
            this.$Modal.error({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          console.log(e);
          this.$Message.error('新建节点人员失败');
        });
      },
      searchUser() {
        if (this.search_user_loading) {
          return;
        }
        this.search_user_loading = true;
        Util.ajax.get(Util.api.query_customer_with_team, {
          params: {
            search: this.search_user_text
          }
        }).then((response) => {
          return response.data;
        }).then((res) => {
          this.search_user_loading = false;
          this.search_user_result = [];
          if (res.code === 1) {
            const data = res.data;
            data.forEach((user) => {
              this.search_user_result.push(user);
            });
          } else {
            this.$Modal.error({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          this.search_user_loading = false;
          console.log(e);
        });
      },
      setUser(node_user, user) {
        this.customers_hash[user.id] = user;
        node_user.user_id = user.id;
        document.body.click();
        this.updateNodeUser(node_user);
      }
    }
  }
</script>
